<template>
  <div>
    <div
      class="tw-border-b tw-border-primary-grey-100/80 tw-bg-primary-grey-100/20 tw-px-4 tw-py-3"
    >
      <div class="tw-grid tw-grid-cols-2 tw-gap-2">
        <div class="tw-justify-self-start tw-font-semibold">
          {{ $t("email-title") }}
        </div>
        <div class="tw-justify-self-end tw-font-semibold">
          {{ $t("targeted") }}
        </div>
      </div>
    </div>
    <div
      v-for="user in users"
      :key="user.email"
      class="[&:not(:last-child)]:tw-border-b tw-border-primary-grey-100/80 tw-bg-white tw-px-4 tw-py-3"
    >
      <div class="tw-grid tw-grid-cols-2 tw-gap-2">
        <div class="tw-justify-self-start tw-font-semibold">
          <span
            v-if="user.email.length > 30"
            v-truncate="30"
            v-tippy="{
              content: user.email,
              placement: 'bottom',
            }"
          >
            {{ user.email }}
          </span>
          <span v-else>{{ user.email }}</span>
        </div>
        <div class="tw-justify-self-end tw-font-semibold">
          {{ user.count }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { TargetedUser } from "./types/TargetedUsers";

defineProps<{ users: TargetedUser[] }>();
</script>
